import React,{useContext} from 'react';
import TimeTableContext from '../../../context/timeTableContext'

const WeeklyChanges = () => {
    const context = useContext(TimeTableContext);

    return ( 
        <div>cccc</div>
     );
}
 
export default WeeklyChanges;